import { FieldValueLookupError } from '../../../common/errors';
import type { UserPickerPublicSetValue } from '../../../common/fields/user-picker';
import type { LookupUser, LookupUsers } from '../../../common/types/lookup';
import { singleValueLookup } from '../../../common/utils/single-value-lookup';

export type UserPickerPublicGetValue = null | {
	accountId: string;
};

export type UserPickerInternalValue =
	| undefined
	| null
	| {
			id: string;
			name: string;
			avatarUrl?: string;
	  };

export const userPickerSetValueTransformer = (
	value: UserPickerPublicSetValue,
	lookupValues?: LookupUsers,
): UserPickerInternalValue => {
	if (value === null) {
		return null;
	}

	const foundValue = singleValueLookup<LookupUser>(value, lookupValues, 'accountId');

	if (!foundValue) {
		throw new FieldValueLookupError();
	}

	return {
		id: foundValue.accountId,
		name: foundValue.name,
		avatarUrl: foundValue.picture,
	};
};

export const userPickerGetValueTransformer = (
	value: UserPickerInternalValue,
): UserPickerPublicGetValue => {
	if (!value) {
		return null;
	}

	const { id: accountId } = value;
	return { accountId };
};
